/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MovePromptCodeUp$Params {
  promptCodeID?: number;
}

export function MovePromptCodeUp(http: HttpClient, rootUrl: string, params?: MovePromptCodeUp$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MovePromptCodeUp.PATH, 'post');
  if (params) {
    rb.query('promptCodeID', params.promptCodeID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MovePromptCodeUp.PATH = '/api/Supervisor/MovePromptCodeUp';
